export default __webpack_public_path__ + "static/cardTabImg2-c576d4a021817a51baa984200c6a931d.webp";